import { CustomAlert, CustomModal, ProtectedImg, ProtectedLink } from "components";
import { Button } from "reactstrap";
import { getFileExtension } from "utils/getFileExtension";
import { tConv24 } from "utils/dateHelper";
import { useMutation } from "react-query";
import apiService from "services/api";
import { useCallback } from "react";
import useModalReducer from "hooks/useModal";
import { useNotificationContext } from "contexts";

const ApproveAttendanceModal = ({ show, data, hideModal, refetch }) => {
	const { createNotification } = useNotificationContext();
	const { mutate: approveAttendanceApplication, isLoading: isApprovingAttendanceApplication } = useMutation(
		() => apiService.attendance.application.approve(data?.id),
		{
			onSuccess: () => {
				createNotification({ type: "success", message: "Successfully approved attendance" });
				refetch();
				hideApproveAttendanceApplicationModal();
				hideModal();
			},
		}
	);
	const { state, dispatch, actions } = useModalReducer();
	const openApproveAttendanceApplicationModal = useCallback((row) => dispatch({ type: actions.OPEN, payload: row }), []);
	const hideApproveAttendanceApplicationModal = useCallback((row) => dispatch({ type: actions.CLOSE, payload: row }), []);

	return (
		<>
			<CustomAlert
				title="Approve attendance application"
				show={state?.open}
				hideModal={hideApproveAttendanceApplicationModal}
				disabled={isApprovingAttendanceApplication}
				description="Are you sure you want to approve attendance application?"
				submitModal={approveAttendanceApplication}
				submitButtonText="Approve"
			/>
			<CustomModal
				show={show}
				hideModal={hideModal}
				compact={true}
				title="Approve Attendance Modal"
				children
				buttons={
					<div className="d-flex justify-center">
						<Button
							color="info"
							disabled={isApprovingAttendanceApplication || data?.isApproved}
							type="button"
							onClick={() => openApproveAttendanceApplicationModal(data)}
						>
							Approve
						</Button>
					</div>
				}
				triggerAlertWhenClose={false}
				triggerAlertMessageWhenClose=""
				centered={true}
				zIndex={0}
			>
				<div className="row text-white px-4 text-left">
					<div className="col-12 col-sm-6 mb-4">
						<div className="font-weight-bold text-primary">Attendance Date</div>
						<div>{data?.attendanceDate}</div>
					</div>
					<div className="col-12 col-sm-6 mb-4">
						<div className="font-weight-bold text-primary">Attendance Time</div>
						<div style={{ textTransform: "uppercase" }}>{tConv24(data?.attendanceTime) + " (" + data?.attendanceType + ")"}</div>
					</div>
					<div className="col-12 col-sm-6 mb-4">
						<div className="font-weight-bold text-primary">Remark</div>
						<div>{data?.remark}</div>
					</div>

					<div className="col-12 col-sm-6 mb-4">
						<div className="font-weight-bold text-primary">Staff</div>
						<div>{data?.staff?.fullName}</div>
					</div>

					{data?.proofImgPaths && (
						<div className="col-12 text-left">
							<div className="font-weight-bold text-primary">Proof</div>
							{data?.proofImgPaths?.map((imgPath) =>
								getFileExtension(imgPath) === "pdf" ? (
									<ProtectedLink href={imgPath} target="_blank" className="badge badge-secondary" label="Click To View Proof" />
								) : (
									<ProtectedImg src={imgPath} alt="" className="img-fluid" />
								)
							)}
						</div>
					)}
				</div>
			</CustomModal>
		</>
	);
};

export default ApproveAttendanceModal;
